<template>
    <div class="contactanos">
        <span>Comience a transformar su empresa hoy</span>
        <div class="dvBoton">
            <router-link to="Contacto">Contactanos</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Contactanos"
    }
</script>

<style scoped lang="scss">
    @import "../style/base";

    .contactanos {
        margin-top: 25px;
        padding-top: 15px;
        height: 165px;
        width: 100%;
        background: #000000;
        @include flexColumn;
        @include absoluteCenter;
        @include Montserrat;
        @include fontFormat(18px, 500, #FFFFFF);
        position: relative;

        & a {
            color: #FFFFFF;
        }

        &:AFTER {
            content: " ";
            position: absolute;
            width: 0;
            height: 0;
            border-left: 30px solid transparent;
            border-right: 30px solid transparent;
            border-top: 30px solid #FFFFFF;
            top: 0;
        }

        & .dvBoton {
            @include botonDefault;
            font-size: 12px;
            margin-top: 10px;

        }


        @include responsive_layout('small') {
            @include flexRow;
            height: 145px;
            & .dvBoton {
                margin-left: 20px;
                margin-top: 0;
            }
        }

    }

</style>